<template>
  <HeaderComp/>
  
  <HomeView v-if="!showForm && !showGuide"/>

  <div v-if="showForm">
    <FormView v-show="!showPreview" @generated="generated"/>
    <PreviewView v-if="showPreview" :videoData="videoData" @back="showPreview = false"/>
  </div>

  <UserGuideView v-if="showGuide" />

  <FooterComp/>
</template>

<script>
import HeaderComp from '@/components/HeaderComp.vue'

import HomeView from '@/views/HomeView.vue'
import FormView from '@/views/FormView.vue'
import PreviewView from '@/views/PreviewView.vue'

import UserGuideView from '@/views/UserGuideView.vue'

import FooterComp from '@/components/FooterComp.vue'
export default {
  name: 'RootComp',
  data:()=>{
    return {
      showForm:false,
      showPreview:false,
      videoData:null,
      showGuide: false
    }
  },
  components: {
    HeaderComp,
    HomeView,
    FormView,
    PreviewView,
    FooterComp,
    UserGuideView
  },
  methods:{
    generated(data){
      this.videoData = data
      this.showPreview = true
    }
  },
  mounted(){
    const urlParams = new URLSearchParams(window.location.search);
    this.showForm = urlParams.get('action') == 'form';
    this.showGuide = urlParams.get('action') == 'user_guide';
  }
}
</script>

<style>

nav {
  padding: 30px;
  text-align: center;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
